import React, { useState } from "react";
import html2pdf from "html2pdf.js";

export default function ResumeBuilder() {
  const [name, setName] = useState("");
  const [summary, setSummary] = useState("");

  const handleDownload = () => {
    const element = document.getElementById("resume-preview");
    html2pdf().from(element).save("resume.pdf");
  };

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">Resume Builder</h2>
      <input
        type="text"
        placeholder="Your Name"
        className="border p-2 w-full"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />
      <textarea
        placeholder="Professional Summary"
        className="border p-2 w-full"
        value={summary}
        onChange={(e) => setSummary(e.target.value)}
      />
      <button onClick={handleDownload} className="bg-blue-500 text-white px-4 py-2 rounded">
        Download PDF
      </button>
      <div id="resume-preview" className="mt-4 p-4 border">
        <h1 className="text-lg font-bold">{name}</h1>
        <p>{summary}</p>
      </div>
    </div>
  );
}
